/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppManagedBillingAssociation } from './WhatsAppManagedBillingAssociation';
/**
 * Comos-funded WhatsApp billing snapshot.
 */
export type WhatsAppComosManagedBilling = {
    /**
     * Comos manages the customer's Meta billing facility.
     */
    mode: WhatsAppComosManagedBilling.mode;
    /**
     * External association used to provide the managed billing facility.
     */
    managedBilling: WhatsAppManagedBillingAssociation;
};
export namespace WhatsAppComosManagedBilling {
    /**
     * Comos manages the customer's Meta billing facility.
     */
    export enum mode {
        COMOS_MANAGED = 'comos_managed',
    }
}

